import React from "react";
import ErrorPage from "peggirkit/dist/components/Dashboard/Page/ErrorPage/ErrorPage";
import {authPageProps} from "@widgets/auth/AuthenticationPage";
import {useIntl} from "react-intl";
import ErrorLinks from "@widgets/error/ErrorLinks";

const Error = () => {
    const intl = useIntl();

    return (
        <ErrorPage
            {...authPageProps("pageNotFound", intl)}
            title={intl.formatMessage({id: "pageNotFound"})}
            linkList={ErrorLinks()}
        />
    );
};

export default Error;